import { render, staticRenderFns } from "./cvInforReviewList.vue?vue&type=template&id=de9932d6&scoped=true"
import script from "./cvInforReviewList.vue?vue&type=script&lang=js"
export * from "./cvInforReviewList.vue?vue&type=script&lang=js"
import style0 from "./cvInforReviewList.vue?vue&type=style&index=0&id=de9932d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9932d6",
  null
  
)

export default component.exports